import * as Yup from 'yup'

export default Yup.object().shape({
  status: Yup.string()
    .oneOf(['active', 'inactive'])
    .required(),
  description: Yup.string().required(),
  code: Yup.string().required(),
  status: Yup.string().oneOf(['active', 'inactive']),
  value: Yup.string().required(),
  expiration_date: Yup.object().shape({ startDate: Yup.mixed().required(), endDate: Yup.mixed().required() }),
})
